/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errors_GenericInputs */

const en_errors_generic = /** @type {(inputs: Errors_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something went wrong`)
};

/**
* | output |
* | --- |
* | "Something went wrong" |
*
* @param {Errors_GenericInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const errors_generic = /** @type {((inputs?: Errors_GenericInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errors_GenericInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_errors_generic(inputs)
});